import { Component, Input } from '@angular/core';

@Component({
    selector: 'zp-toolbar-popover',
    templateUrl: './toolbar-popover.component.html',
    styleUrls: [
        './toolbar-popover.component.scss'
    ],
    standalone: true
})
export class ToolbarPopoverComponent {

    @Input()
    public title = '';

    @Input()
    public popoverDataId = 'toolbar-popover';

}
